
export default [
  {
    path: '/',

    name: 'mall',

    meta: {

      title: '车U汇官网',

      loginRequire: true,

      index: 1

    },

    component: () => import('@/pages/mall/index'),

  },

  {
    path: '/top',

    name: 'top',

    meta: {

      title: '首页',

      loginRequire: true,

      index: 2


    },

    component: () => import('@/pages/mall/home')

  },

  {
    path: '/contactus',

    name: 'contactus',

    meta: {

      title: '联系我们',

      loginRequire: true,

      index: 4


    },

    component: () => import('@/pages/mall/contactus')

  },
  // {
  //   path: '/download',

  //   name: 'download',

  //   meta: {

  //     title: 'download',

  //     loginRequire: true,

  //     index: 4


  //   },

  //   component: () => import('@/pages/mall/download')

  // },
  // {
  //   path: '',

  //   name: 'phone',

  //   meta: {

  //     title: 'phone',

  //     loginRequire: true,

  //     index: 5


  //   },

  //   component: () => import('@/pages/mall/phone')

  // },

  {
    path: '/about',

    name: 'about',

    meta: {

      title: '关于我们',

      loginRequire: true,

      index: 3,



    },

    component: () => import('@/pages/mall/about'),


  },

  {
    path: '/activityLists',

    name: 'activityLists',

    meta: {

      title: '活动列表',

      loginRequire: true,

      index: 5,

      keepAlive: true

    },

    component: () => import('@/pages/mall/activityLists'),


  },
  {
    path: '/activityDetails',

    name: 'activityDetails',

    meta: {

      title: '活动详情',

      loginRequire: true,

      index: 6,

    },

    component: () => import('@/pages/mall/activityDetails'),


  }

]




// WEBPACK FOOTER //
// ./src/router/mall.js